import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONSTANTS, palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread({}, helpers), {}, {
  isOpen: {
    backgroundColor: palette.shades[300],
    '& .MuiSvgIcon-root path': {
      fill: palette.shades[800]
    },
    '&:before': {
      content: 'none'
    },
    '&:hover': {
      background: palette.shades[300]
    }
  },
  drawer: {
    '& .MuiDrawer-paper': {
      paddingTop: "".concat(CONSTANTS.NEW_HEADER_HEIGHT + 'px'),
      alignItems: 'stretch',
      justifyContent: 'space-between'
    }
  },
  notifications: {},
  actions: {
    padding: '18px 24px',
    backgroundColor: palette.shades[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  notificationContent: {
    display: 'flex',
    minWidth: '566px',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '22px',
    borderBottom: "1px solid ".concat(palette.shades[400])
  },
  info: {
    fontSize: '13px',
    lineHeight: '16px',
    fontFamily: palette.fontFamilies.source
  },
  time: {
    marginRight: '10px',
    '& .MuiTypography-root + .MuiTypography-root': {
      marginTop: '8px'
    }
  },
  notificationText: {
    fontSize: '15px',
    lineHeight: '19px',
    marginTop: '5px'
  }
}));
export default useStyles;